module.exports = __webpack_public_path__ + "img/watermark.a26a9539.png";